import { Theme, themedValue } from '../__styling'
import { EmailPreferenceSection } from './components/PreferenceSection'

export const thewestEmailPreferenceContent: EmailPreferenceSection[] = [
    // Newsletters
    {
        sectionTitle: 'Newsletters',
        sectionItems: [
            {
                id: 'wan_newsletter-west-news',
                name: 'News Headlines',
                description: 'Daily news headlines from our newsroom',
                frequency: 'Daily',
                subAccount: 'wan_newsletter',
                guid: '93608454-6e74-4124-aee0-5fc3cb6ac325',
                unSubId: 15560,
            },
            {
                id: 'wan_newsletter-west-sport',
                name: 'Sports News',
                description: 'The latest in Sport from The West Australian',
                frequency: 'Twice Daily',
                subAccount: 'wan_newsletter',
                guid: 'f2e2972f-702f-4186-8477-914385f3ebab',
                unSubId: 15112,
            },
            {
                id: 'wan_newsletter-west-business',
                name: 'Business News',
                description: 'The latest in Business from The West Australian',
                frequency: 'Daily',
                subAccount: 'wan_newsletter',
                guid: 'e84aa87a-4d29-497e-beda-910dc3fcc066',
                unSubId: 15559,
            },
            {
                id: 'wan_newsletter-west-tomorrows-front-page',
                name: `Tomorrow's Front Page`,
                description: 'Daily preview of tomorrow’s newspaper',
                frequency: 'Daily',
                subAccount: 'wan_newsletter',
                guid: 'e13d2836-8285-4ba3-a676-331dfdae13bc',
                unSubId: 15866,
            },
            {
                id: 'wan_newsletter-west-bulls-n-bears',
                name: `Bulls N' Bears | Public Companies`,
                description: 'The latest news on ASX-listed public companies',
                frequency: 'Weekly',
                subAccount: 'wan_newsletter',
                guid: '388ca061-a385-4a40-97be-50ae2e3859ff',
                unSubId: 15979,
            },
            {
                id: 'wan_travelclub-enews',
                name: `West Travel Club`,
                description:
                    'eTravel Newsletter with travel stories from experts',
                frequency: 'Weekly',
                subAccount: 'wan_travelclub',
                guid: '4417dc4b-2b8a-4b77-87b7-fc8256510c4a',
                unSubId: 161727,
            },
            {
                id: 'wan_newsletter-ewest-wheels',
                name: `eWest Wheels`,
                description: 'Motoring stories from our experts',
                frequency: 'Weekly',
                subAccount: 'wan_newsletter',
                guid: '0b633a89-26b5-4acc-9953-e3fd72b06d63',
                unSubId: 19268,
            },
        ],
        subscriberOnly: false,
    },
    // Subscriber Exclusive
    {
        sectionTitle: 'Subscriber Exclusive Newsletters',
        sectionItems: [
            {
                id: 'wan_promotions-west-rewards',
                name: 'West Rewards',
                description: 'Subscriber competitions, discounts and giveaways',
                frequency: undefined,
                subAccount: 'wan_promotions',
                guid: 'ebb36192-54a7-45f5-af77-716c9f6ce5dc',
                unSubId: 14583,
            },
            {
                id: 'wan_promotions-west-exclusive-content',
                name: 'Exclusive Content',
                description: 'Special series and features as they drop',
                frequency: undefined,
                subAccount: 'wan_promotions',
                guid: 'ebb36192-54a7-45f5-af77-716c9f6ce5dc',
                unSubId: 16232,
            },
            {
                id: 'wan_newsletter-west-note-from-editor',
                name: 'Note from the Editor',
                description: 'Hear from our Editor in Chief, Anthony De Ceglie',
                frequency: undefined,
                subAccount: 'wan_newsletter',
                guid: '854ad4ae-b06d-424f-a038-92fd390fa922',
                unSubId: 18912,
            },
        ],
        subscriberOnly: true,
    },
    // Marketing & Promotions
    {
        sectionTitle: 'Marketing & Promotions',
        sectionItems: [
            {
                id: 'wan_promotions-west-subscription-offers',
                name: 'Subscription Offers',
                description:
                    'Special offers on print & digital subscription packages',
                frequency: undefined,
                subAccount: 'wan_promotions',
                guid: 'ebb36192-54a7-45f5-af77-716c9f6ce5dc',
                unSubId: 16216,
            },
            {
                id: 'wan_promotions-west-competitions',
                name: 'Competitions',
                description: 'Regular oppurtunities to win great prizes',
                frequency: undefined,
                subAccount: 'wan_promotions',
                guid: 'ebb36192-54a7-45f5-af77-716c9f6ce5dc',
                unSubId: 16005,
            },
            // Turning it off for now, until serverless-mono delploy is fixed
            // {
            //     id: 'wan_promotions-west-partner-promotions',
            //     name: 'Partner Promotions',
            //     description: 'Receive exclusive offers from our partners',
            //     frequency: undefined,
            //     subAccount: 'wan_promotions',
            //     guid: 'ebb36192-54a7-45f5-af77-716c9f6ce5dc',
            //     unSubId: 18797,
            // },
            // {
            //     id: 'wan_promotions-west-surveys',
            //     name: 'Surveys',
            //     description: 'Provide meaningful feedback to help us improve',
            //     frequency: undefined,
            //     subAccount: 'wan_promotions',
            //     guid: 'ebb36192-54a7-45f5-af77-716c9f6ce5dc',
            //     unSubId: 18780,
            // },
        ],
        subscriberOnly: false,
    },
]

export const perthnowEmailPreferenceContent: EmailPreferenceSection[] = [
    // Newsletters
    {
        sectionTitle: 'Newsletters',
        sectionItems: [
            {
                id: 'wan_newsletter-perthnow-news-briefing',
                name: 'News Briefing',
                description: 'Daily news headlines from our newsroom',
                frequency: 'Daily',
                subAccount: 'wan_newsletter',
                guid: '2f9ca2c1-d268-45c2-b521-f16e17354bc5',
                unSubId: 15108,
            },
            {
                id: 'wan_newsletter-perthnow-local',
                name: 'Local',
                description: 'Twice-weekly headlines from your local area',
                frequency: 'Twice Weekly',
                subAccount: 'wan_newsletter',
                guid: '945e6f86-bfbe-4513-a018-5cd8288d3477',
                unSubId: 16984,
            },
            {
                id: 'wan_newsletter-perthnow-todays-paper',
                name: 'Weekly Paper',
                description: 'Weekly preview of your PerthNow Local newspapers',
                frequency: 'Weekly',
                subAccount: 'wan_newsletter',
                guid: 'b5c2e60e-79f4-4c29-9e87-a41b86838fa6',
                unSubId: 18378,
            },
        ],
        subscriberOnly: false,
    },
    // Marketing & Promotions
    {
        sectionTitle: 'Marketing & Promotions',
        sectionItems: [
            {
                id: 'wan_promotions-west-competitions',
                name: 'Competitions',
                description: 'Regular opportunities to win great prizes',
                frequency: 'Daily',
                subAccount: 'wan_promotions',
                guid: 'ebb36192-54a7-45f5-af77-716c9f6ce5dc',
                unSubId: 18778,
            },
            {
                id: 'wan_promotions-perthnow-partner-promotions',
                name: 'Partner Promotions',
                description: 'Receive exclusive offers from our partners',
                frequency: undefined,
                subAccount: 'wan_promotions',
                guid: 'ebb36192-54a7-45f5-af77-716c9f6ce5dc',
                unSubId: 18779,
            },
            {
                id: 'wan_promotions-perthnow-surveys',
                name: 'Surveys',
                description: 'Provide meaningful feedback to help us improve',
                frequency: undefined,
                subAccount: 'wan_promotions',
                guid: 'ebb36192-54a7-45f5-af77-716c9f6ce5dc',
                unSubId: 18780,
            },
        ],
        subscriberOnly: false,
    },
]

const preferenceOptions = {
    thewest: [thewestEmailPreferenceContent, perthnowEmailPreferenceContent],
    perthnow: [perthnowEmailPreferenceContent, thewestEmailPreferenceContent],
    fallback: [],
}

export function getMastheadPreferences(
    theme: Theme,
): EmailPreferenceSection[][] {
    return themedValue<
        EmailPreferenceSection[][],
        EmailPreferenceSection[][],
        EmailPreferenceSection[][]
    >(theme, preferenceOptions)
}
